import { createUseStyles } from 'react-jss';
import {
  BackgroundColors,
  TextColors,
} from '@picsart/design-system/foundation/colors';

const useStyles = createUseStyles(
  {
    // Mirrors the grid `EditorBlank` provided before DS v13 removed it:
    // an auto-height header row above a body row that takes the rest.
    mobile: {
      display: 'grid',
      gridTemplateRows: 'auto 1fr',
      gridTemplateColumns: '1fr',
      height: '100%',
      width: '100%',
      color: TextColors.base,
      backgroundColor: BackgroundColors.base,
      // Matches the DS `__common` guard that keeps grid rows from overflowing.
      '& > *': {
        minWidth: 0,
        minHeight: 0,
      },
    },
    // A surface that provides its own header (PortfolioShell) is the grid's
    // only child, so auto-placement drops it in the `auto` row above. Its
    // `height: 100%` then resolves against a content-sized row, making the
    // whole subtree's height content-driven instead of viewport-driven — the
    // profile's scroll area came out as short as whatever had rendered by the
    // time the row was sized. One row, always `1fr`.
    mobileHeaderless: {
      gridTemplateRows: '1fr',
    },
    desktop: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%',
      color: TextColors.base,
      overflow: 'hidden',
    },
  },
  { name: 'appLayout' }
);

export default useStyles;
